module.exports = __webpack_public_path__ + "static/car_product_5-826c9217cea386f6697a32f33fd5de1b.jpg";